export const APP_CONFIG = {
  appName: 'Palo Alto',
  frontend: 'https://benefits.paloaltonetworks.com',
  api: '/api/2.0',
  authHeaders: {
    xServiceProvider: 'palo-prod-frontend',
    'tenant-id': '49636f5c-40db-4fcd-9c55-3f2e564fc693',
    'consumer-id': 'bec3c6ce-c380-471b-8f2f-2360f220dffa',
  },
  provider: 'palo-prod-frontend',
  version: '1.0.0',
  bs4v: '4.3',
  multilingual: true,
  gtm: 'GTM-53BPVGT',
  copyright: '<small>&copy; ' + new Date().getFullYear() +
      ' Gallagher | All Rights Reserved.' + '<br />Powered by Core.' + '</small>',
  contactEnabled: false,
  navigation: {
    navType: 'top',
    collapsibleSidenav: false,
    headerStyle: 'solid',
    categoryNav: false
  }
};

